export default __webpack_public_path__ + "toon-boom-harmony.48f890ec.png";